import React from 'react';
import './Checkbox.css';

/**
 * Standalone checkbox: a native <input type="checkbox"> wrapped in its own
 * visible, accessible <label> -- never a styled div/span standing in for
 * the control. Not meant to be nested inside FormField's `children`
 * (FormField's label+required/optional semantics don't apply well to a
 * control that already carries its own label); use Checkbox directly.
 *
 * @param {string} [id]
 * @param {React.ReactNode} label  Visible, accessible label text.
 * @param {boolean} [checked]
 * @param {boolean} [defaultChecked]
 * @param {(event: React.ChangeEvent) => void} [onChange]
 * @param {boolean} [disabled=false]
 * @param {boolean} [error=false]  Sets aria-invalid and error styling.
 */
function Checkbox({
  id,
  label,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  error = false,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-checkbox',
    disabled ? 'ui-checkbox--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <label className={classes}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
        aria-invalid={error || undefined}
        className="ui-checkbox__input"
        {...rest}
      />
      {label ? <span className="ui-checkbox__label">{label}</span> : null}
    </label>
  );
}

export default Checkbox;
